<template>
    <div class="wrapper">
        <div class="previous arrow-btn" @click="previous">
            <i class="fas fa-chevron-left" aria-hidden="true"></i>
        </div>
        <div class="slider-container" id="testimonial-container">
            <div class="slider" :style="{width: sliderWidth + 'px', left: leftPosition + 'px'}" id="testimonial-slider">
                <div class="slide" v-for="(testimonial, index) in testimonials"
                     v-touch:swipe.left="next"
                     v-touch:swipe.right="previous"
                     :key="index"
                     :id="`testimonial-slide-${index}`"
                     :style="{width: slideWidth + 'px'}">
                    <div class="quote p-3 p-xl-5">
                        <blockquote>
                            <span class="blockquote-img"></span>
                            <p v-html="testimonial.post_content"></p>
                            <span class="blockquote-img flipped"></span>
                            <footer>— {{ testimonial.settings.author }}</footer>
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>

        <div class="next arrow-btn" @click="next">
            <i class="fas fa-chevron-right" aria-hidden="true"></i>
        </div>

        <div class="indicators text-center mt-4">
            <span class="d-inline-block mr-4 indicator"
                  :class="{
                      'active': currentSlide === index
                  }"
                  aria-hidden="true"
                  @click="setSlide(index)"
                  v-for="(_, index) in testimonials"></span>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Velocity from 'velocity-animate'

export default {
    name: 'Testimonials',
    props: {
        selectedCategory: {
            type: String,
            default: 'General'
        }
    },
    data() {
        return {
            testimonials: [],
            currentSlide: 0,
            sliderWidth: 0,
            slideWidth: 0,
            sliderHeight: 250,
            leftPosition: 0
        }
    },
    computed: {
        isMobile() {
            let windowWidth = window.innerWidth
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                    windowWidth < 991
        }
    },
    created() {
        window.addEventListener('resize', this.setSliderDimensions)
    },
    mounted() {
        this.getTestimonials()
        document.getElementById('testimonial-container').style.overflowX = 'hidden'
    },
    destroyed() {
        window.removeEventListener('resize', this.setSliderDimensions)
    },
    methods: {
        getTestimonials() {
            let formData = new FormData
            formData.append('action', 'get_testimonials')
            formData.append('per_page', '10')
            if (this.selectedCategory !== 'all') {
                formData.append('slug', this.selectedCategory)
            }
            axios.post(ajaxObject.url, formData).then((response) => {
                this.testimonials = response.data.data.testimonials
                setTimeout(() => {
                    this.setSliderDimensions()
                }, 300)
            })
        },
        next() {
            this.currentSlide++
            this.checkSlide()
            this.smoothSlide()
        },
        previous() {
            this.currentSlide--
            this.checkSlide()
            this.smoothSlide()
        },
        setSlide(index) {
            this.currentSlide = index
            this.checkSlide()
            this.smoothSlide()
        },
        checkSlide() {
            let total = this.testimonials.length

            if (this.currentSlide >= total) {
                this.currentSlide = 0
            }

            if (this.currentSlide <= -1) {
                this.currentSlide = total - 1
            }
        },
        smoothSlide() {
            let slideEl = document.getElementById('testimonial-slide-' + this.currentSlide)
            this.leftPosition = -1 * slideEl.offsetLeft
            this.sliderHeight = slideEl.children[0].offsetHeight

            if (this.isMobile) {
                let container = document.getElementById('testimonial-container')
                Velocity(container.parentElement, 'scroll', {duration: 500, easing: 'easeInSine'})
            }
        },
        setSliderDimensions() {
            if (this.testimonials.length <= 0) {
                this.sliderWidth = 0
                return
            }

            let containerWidth = document.getElementById('testimonial-container').offsetWidth
            this.sliderWidth = containerWidth * this.testimonials.length * 1.25
            if (this.isMobile) {
                this.slideWidth = window.innerWidth - 40
            } else {
                this.slideWidth = (containerWidth / 2) - 40
            }
        },
    },
}
</script>

<style scoped lang="scss">
@import "./../../../scss/variables.scss";

.wrapper {
    position: relative;
    padding: 20px;

    .slider-container {
        position: relative;
        display: block;
        overflow-x: scroll;
        overflow-y: hidden;
        width: 100%;
        height: 320px;

        .slider {
            position: absolute;
            top: 0;
            left: 0;
            transition: all .5s ease-in-out;
            overflow-y: hidden;

            .slide {
                float: left;
                margin-left: 40px;

                &:first-child {
                    margin-left: 0;
                }

                .quote {
                    background-color: $gray-100;
                    height: 320px;
                    overflow-y: scroll;

                    blockquote {


                        p {
                            font-size: 20px;
                            font-style: italic;
                        }

                        footer {
                            font-weight: 900;
                            color: $primary;
                        }

                        .blockquote-img {
                            background-image: url('../../../images/blockquote.png');
                            background-repeat: no-repeat;
                            background-size: contain;
                            height: 60px;
                            width: 60px;
                            display: inline-block;
                            float: left;
                            margin-right: 20px;
                            transform: rotate(180deg);

                            &.flipped {
                                transform: rotate(0);
                                float: right;
                                margin-right: 0;
                                margin-left: 20px;
                            }
                        }
                    }
                }
            }
        }
    }

    .arrow-btn {
        position: absolute;
        top: 50%;
        cursor: pointer;
        transform: translateY(-50%);
        font-size: 40px;

        &.previous {
            left: -20px;
        }

        &.next {
            right: -20px;
        }
    }

    .indicators {
        width: 100%;
        text-align: center;

        .indicator {
            border-bottom: 7px solid $gray-300;
            transition: all .5s ease-in-out;
            width: 64px;
            border-radius: 3px;
            cursor: pointer;

            &.active {
                border-color: $gray-500;
            }
        }
    }
}

@media only screen and (max-width: 991px) {
    .wrapper {
        .slider-container {
            .slider {
                .slide {
                    width: 460px !important;

                    .quote {
                        blockquote {
                            .blockquote-img {
                                height: 30px;
                                width: 30px;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 380px) {
    .wrapper {
        padding: 0;

        .slider-container {
            .slider {
                .slide {
                    blockquote {
                        padding: 0;
                    }
                }
            }
        }
    }

}

@media only screen and (max-width: 460px) and (orientation: portrait) {

    .wrapper {
        .slider-container {
            height: 400px;

            .slider {
                .slide {

                    .quote {
                        height: 400px;
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 460px) and (min-width: 321px) and (orientation: portrait) {
    .wrapper {
        .slider-container {

            .slider {
                .slide {
                    width: 280px !important;
                }
            }
        }
    }
}

@media only screen and (max-width: 340px) and (orientation: portrait) {
    .wrapper {
        .slider-container {
            height: 300px;

            .slider {
                .slide {
                    width: 275px !important;

                    .quote {
                        height: 300px;
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 991px) and (orientation: landscape) {

    .wrapper {
        .slider-container {
            height: 300px;

            .slider {
                .slide {

                    .quote {
                        height: 300px;
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 640px) and (orientation: landscape) {

    .wrapper {
        .slider-container {
            height: 280px;

            .slider {
                .slide {

                    .quote {
                        height: 280px;
                    }
                }
            }
        }
    }
}

</style>